class PointsBadge extends HTMLElement {
  constructor() {
    super()
    this.points = 0
    this['points-classification'] = 'pts'
    this.multiplier = 1
    this['multiplier-classification'] = ''
    this.disabled = false
    this.tags = ''
  }
  connectedCallback() {
    const shadow = this.attachShadow({ mode: 'open' })
    const template = document.getElementById('points-badge').content.cloneNode(true)
    template.querySelector('.point-value').textContent = this.points
    template.querySelector('.point-classification').textContent = this['points-classification']
    if (parseInt(this.multiplier, 10) > 1) {
      template.querySelector('.multiplier-value').textContent = `X${this.multiplier}`
    }

    if (this["multiplier-classification"]) {
      const multiplierClassification = template.querySelector('.multiplier-classification')
      multiplierClassification.textContent = this['multiplier-classification']
      multiplierClassification.style.display = 'block'
    }

    if (this.disabled && this.disabled !== 'false') {
      template.querySelector('.points-badge').classList.add('disabled')
    }

    if (this['points-classification'] !== 'sale item') {
      if (this.tags.includes('nopoints')) {
        this.points = 0
        template.querySelector('.points-badge').style.visibility = 'hidden'
      }
    } else {
      template.querySelector('.points-badge').style.visibility = 'unset'
    }
   
    shadow.appendChild(template)
  }

  attributeChangedCallback(property, oldValue, newValue) {
    if (oldValue === newValue) {
      return
    }

    this[property] = newValue
  }

  static get observedAttributes() {
    return ['points', 'points-classification', 'multiplier', 'multiplier-classification', 'disabled', 'tags']
  }
}

customElements.define('points-badge', PointsBadge)